// @flow @jsx h
import { Component, h } from 'preact'
import { SerumLazyResponsivePicture } from '@nrk/dh-feature-components'

import styles from './index.css'

type Props = {
  id: string,
  alt: string,
  caption: string,
  load: boolean
}

export class BildeBlokk extends Component<Props> {
  render () {
    const { id, alt, caption, load } = this.props
    return <div>
      <figure class={styles.bildeBlokk}>
        <SerumLazyResponsivePicture
          id={id}
          alt={alt}
          sizes={'100vw'}
          ratio={'169'}
          load={load} />
        {caption && <figcaption>{caption}</figcaption>}
      </figure>
    </div>
  }
}
